import useScriptData from '../core/hooks/useScriptData'
import {useCallback} from '@wordpress/element'
import {Swiper, SwiperSlide} from 'swiper/react'
import {Autoplay, EffectFade} from 'swiper/modules'
import {BaseProps} from '../types'

export default function Carousel(props: BaseProps) {
  const { data } = props
  const renderSlides = useCallback(() => {
    if (!Array.isArray(data)) return null
    return data.map((item, index) => {
      return (
        <SwiperSlide key={index}>
          <img className={'rounded-[10px] object-cover w-full'} src={item} alt={'image'}/>
        </SwiperSlide>
      )
    })
  }, [data])

  if (!data) return null
  return (
    <Swiper
      slidesPerView={1}
      modules={[EffectFade, Autoplay]}
      autoplay={{
        delay: 2000
      }}
      effect={'fade'}
    >
      { renderSlides() }
    </Swiper>
  )
}